import { ReturnStatement } from '@angular/compiler';
import { Question } from '../shared/question';
import { Response } from '../shared/response';
import { ApplicationStorage } from './applicationStorage';
//@ts-ignore
import moment from 'moment';

export class SurveyDay14AdoptionG4 {

    age: any;
    segment: any;
    endgame: boolean;
    surveyOutroText: any;
    keepAge: any;

    question1: Question;
    question2: Question;
    question3: Question;
    question4: Question;


    questions: Array<Question>;

    constructor(private applicationStorage: ApplicationStorage) {
        // this.surveyConsumerAgreement = false;//TODO
        this.endgame = false;

        //(0.1)
        this.question1 = new Question(1, [],
            'Cât de mulțumit ești de experiența oferita de dispozitivul Ploom AURA si Sobranie sticks?',
            'de la 1 la 10 (1 fiind cel mai mic scor și 10 fiind cel mai mare)',
            'radio-inline',
            [new Response(0, '1'),
            new Response(1, '2'),
            new Response(2, '3'),
            new Response(3, '4'),
            new Response(4, '5'),
            new Response(5, '6'),
            new Response(6, '7'),
            new Response(7, '8'),
            new Response(8, '9'),
            new Response(9, '10')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true);


        this.question2 = new Question(2, [1],
            'Ce apreciezi cel mai mult la experiența ta cu Ploom AURA si Sobranie Sticks?',
            '',
            'checkbox-free',
            [new Response(0, 'Este mai putin deranjant pentru cei din jurul meu – fara fum, scrum si cu mai putin miros de tutun'),
            new Response(1, ' Este cea mai apropiata experienta de fumatul traditional'),
            new Response(2, ' Apreciez designul dispozitivului, fiind un accesoriu care mă definește și îmi completează stilul'),
            new Response(3, ' Îl pot folosi ca alternativă când fumatul tradițional e interzis și/sau nu este posibil'),
            new Response(4, ' Pentru că grupul meu de prieteni are acest obicei și îmi place să fiu alături de ei'),
            new Response(5, ' Potențial de risc redus* al produsului'),
            new Response(6, ' Apreciez profilul de savoare si imi ofera satisfactie'),
            new Response(7, 'Altele')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true,
        );

        this.question2.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question1Responses = this.question1.responses.filter(r => r.selected).map(r => r.text);
            if (question1Responses.length > 0) {
                return true;
            } else {
                this.question2.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }


         this.question3 = new Question(3, [2],
            'Ce ai îmbunătăți la experiența Ploom AURA?',
            '',
            'checkbox-free',
            [new Response(0, ' Forma, design-ul dispozitivului'),
            new Response(1, '  Functionalitatea, caracteristicile tehnice ale dispozitivului (de ex., durata sesiunii, numarul de sesiuni consercutive, performanta bateriei etc.)'),
            new Response(2, '  Varietate de sortimente – intensitati si profiluri de savoare variate'),
            new Response(3, '  Experienta sa fie la fel de satisfacatoare precum fumatul traditional'),
            new Response(4, '  Usurinta de a gasi produsele Ploom in magazinele pe care le frecventez'),
            new Response(5, 'Altele')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '*Ploom Aura este cea mai recentă inovație a noastră în categoria produselor cu tutun încălzit, concepută pentru a contribui la reducerea riscurilor asociate fumatului. Prin încălzirea tutunului, nu arderea acestuia, Ploom Aura generează, în ansamblu, un nivel mai redus de substanțe nocive în comparație cu fumul de țigaretă.\n\nAceastă evaluare se bazează pe date generate automat, care compară nivelurile anumitor substanțe nocive din aerosolul produs de Ploom cu cele din fumul țigaretei de referință 1R6F.',
            true,
        );

        this.question3.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question2Responses = this.question2.responses.filter(r => r.selected).map(r => r.text);
            if (question2Responses.includes('Altele')) {
                if (this.question2.responses?.[7]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (question2Responses.length > 0) {
                return true;
            } else {
                this.question3.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }


        this.question4 = new Question(4, [3],  // 1a
            'Vei continua sa folosesti noul Ploom AURA?',
            '',
            'radio',
            [new Response(0, 'Da'),
            new Response(1, 'Nu')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true,
        );

          this.question4.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question3Responses = this.question3.responses.filter(r => r.selected).map(r => r.text);
            if (question3Responses.includes('Altele')) {
                if (this.question3.responses?.[5]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (question3Responses.length > 0) {
                return true;
            } else {
                this.question3.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }

        this.questions = [this.question1, this.question2, this.question3, this.question4];

        // console.log(this.questions)

    }


    getQuestions(): Array<Question> {
        return this.questions;
    }






}




